import { ChangeDetectionStrategy, Component, HostBinding, HostListener } from '@angular/core';

@Component({
  selector: 'kh-dropdown-menu-item',
  templateUrl: './dropdown-menu-item.component.html',
  styleUrls: ['./dropdown-menu-item.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class DropdownMenuItemComponent {
  @HostBinding('attr.role') public readonly role = 'menuitem';
  @HostBinding('attr.tabindex') public readonly tabindex = '0';

  @HostListener('keydown.enter', ['$event'])
  @HostListener('keydown.space', ['$event'])
  public onItemKeydown(event: KeyboardEvent): void {
    event.preventDefault();
    (event.currentTarget as HTMLElement).click();
  }
}
